var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    y: 341.33,
    style: {
      fill: "#73AF00"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("rect", {
    y: 170.67,
    style: {
      fill: "#FFE15A"
    },
    width: 512,
    height: 170.67
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M238.597,179.617c0,0-0.347,0.434-0.997,1.247c-0.542,0.75-1.356,1.906-2.244,3.441  c-1.749,3.051-3.583,7.781-3.632,13.42c-0.018,2.749,0.55,6.087,1.488,8.742c1.017,2.93,2.703,5.733,4.836,8.236  c2.136,2.526,4.988,4.473,8.038,5.911c1.513,0.768,3.173,1.209,4.821,1.616c0.817,0.249,1.686,0.262,2.524,0.426  c0.421,0.08,0.857,0.044,1.284,0.077l0.643,0.029l0.321,0.016l0.161,0.009l0.08,0.004l0.04,0.002  c-0.13,0.004,0.347-0.007-0.281,0.01c1.044-0.061,2.311-0.069,3.172-0.173c0.751-0.175,1.383-0.144,2.243-0.4  c1.648-0.407,3.308-0.848,4.821-1.616c3.05-1.438,5.903-3.386,8.038-5.911c2.132-2.503,3.819-5.305,4.836-8.236  c0.973-2.982,1.493-5.833,1.486-8.754c-0.047-5.614-1.883-10.361-3.631-13.408c-0.883-1.529-1.7-2.692-2.281-3.475  c-0.604-0.772-0.926-1.184-0.926-1.184l-0.081-0.103c-0.58-0.741-0.45-1.813,0.292-2.393c0.585-0.458,1.379-0.471,1.971-0.093  c0,0,0.497,0.319,1.43,0.917c0.882,0.661,2.249,1.599,3.722,3.112c2.956,2.926,6.794,8.141,8.178,15.719  c0.685,3.626,0.76,8.013-0.185,12.326c-0.916,4.356-2.773,8.86-5.772,12.802c-2.945,3.959-6.903,7.461-11.609,9.823  c-2.32,1.238-4.848,2.137-7.44,2.762c-1.242,0.365-2.819,0.516-4.224,0.737c-1.316,0.145-2.252,0.148-3.398,0.228l-0.446,0.002  l-0.125-0.006l-0.25-0.012l-0.501-0.025l-1.001-0.054c-0.666-0.054-1.336-0.044-1.997-0.159c-1.317-0.232-2.658-0.34-3.943-0.712  c-2.592-0.626-5.12-1.524-7.44-2.762c-4.706-2.362-8.664-5.864-11.609-9.823c-2.999-3.942-4.856-8.447-5.772-12.802  c-0.98-4.64-0.857-8.541-0.184-12.338c1.382-7.553,5.222-12.786,8.177-15.707c1.468-1.507,2.839-2.452,3.759-3.146  c0.886-0.557,1.359-0.854,1.359-0.854c0.803-0.504,1.862-0.262,2.367,0.54C239.113,178.261,239.039,179.063,238.597,179.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M252.614,313.795v21.324c0,2.127-2.572,3.193-4.076,1.689l-1.173-1.173  c-0.975-0.975-1.522-2.297-1.522-3.675v-18.164h6.771L252.614,313.795L252.614,313.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M242.456,310.409v15.477c0,0.931,0.37,1.823,1.028,2.481l2.358,2.358v-20.317h-3.386V310.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M239.07,310.409v8.307c0,1.186,0.471,2.323,1.309,3.161l2.077,2.077V310.41h-3.386V310.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M259.386,313.795v21.324c0,2.127,2.572,3.193,4.076,1.689l1.173-1.173  c0.975-0.975,1.522-2.297,1.522-3.675v-18.164h-6.771V313.795z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M269.545,310.409v15.477c0,0.931-0.37,1.823-1.028,2.481l-2.358,2.358v-20.317h3.386L269.545,310.409  L269.545,310.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M272.931,310.409v8.307c0,1.186-0.471,2.323-1.309,3.161l-2.077,2.077V310.41h3.386V310.409z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M272.931,249.459l37.247-27.089v55.707c0,15.986-12.959,28.945-28.945,28.945l0,0  c-5.425,0-10.741-1.525-15.341-4.4l-20.049-12.531v-41.103L272.931,249.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M296.633,232.221v39.084c0,15.986-12.959,28.945-28.945,28.945c-2.403,0-4.774-0.347-7.082-0.931  l-14.764-9.228v-41.103l27.089,0.47L296.633,232.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M286.475,239.609v25.232c0,15.986-12.959,28.945-28.945,28.945c-2.403,0-4.774-0.347-7.082-0.931  l-4.606-2.879v-40.988l27.089,0.47L286.475,239.609z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "312.209,216.276 327.108,208.826 316.273,222.371 310.178,222.371 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M293.247,266.39l37.247-27.089v55.707c0,15.986-12.959,28.945-28.945,28.945l0,0  c-5.425,0-10.741-1.525-15.341-4.4l-20.049-12.531V265.92L293.247,266.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M306.792,256.54v25.232c0,15.986-12.959,28.945-28.945,28.945c-2.403,0-4.774-0.347-7.082-0.931  l-4.606-2.879V265.92l27.089,0.47L306.792,256.54z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "332.526,233.206 347.425,225.757 336.589,239.301 330.494,239.301 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M283.089,259.618l37.247-27.089v55.707c0,15.986-12.959,28.945-28.945,28.945l0,0  c-5.425,0-10.741-1.525-15.341-4.4L256,300.251v-41.103L283.089,259.618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M306.792,242.38v39.084c0,15.986-12.959,28.945-28.945,28.945c-2.403,0-4.774-0.347-7.082-0.931  L256,300.251v-41.103l27.089,0.47L306.792,242.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M296.633,249.767v25.232c0,15.986-12.959,28.945-28.945,28.945c-2.403,0-4.774-0.347-7.082-0.931  L256,300.135v-40.988l27.089,0.47L296.633,249.767z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "322.368,226.434 337.266,218.985 326.431,232.529 320.336,232.529 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M239.07,249.459l-37.247-27.089v55.707c0,15.986,12.959,28.945,28.945,28.945l0,0  c5.425,0,10.741-1.525,15.341-4.4l20.049-12.531v-41.103L239.07,249.459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M215.367,232.221v39.084c0,15.986,12.959,28.945,28.945,28.945c2.403,0,4.774-0.347,7.082-0.931  l14.764-9.228v-41.103l-27.089,0.47L215.367,232.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M225.525,239.609v25.232c0,15.986,12.959,28.945,28.945,28.945c2.403,0,4.774-0.347,7.082-0.931  l4.606-2.879v-40.988l-27.089,0.47L225.525,239.609z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "199.791,216.276 184.892,208.826 195.728,222.371 201.823,222.371 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M218.753,266.39l-37.247-27.089v55.707c0,15.986,12.959,28.945,28.945,28.945l0,0  c5.425,0,10.741-1.525,15.341-4.4l20.049-12.531V265.92L218.753,266.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M205.209,256.54v25.232c0,15.986,12.959,28.945,28.945,28.945c2.403,0,4.774-0.347,7.082-0.931  l4.606-2.879V265.92l-27.089,0.47L205.209,256.54z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "179.475,233.206 164.576,225.757 175.411,239.301 181.506,239.301 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M228.912,259.618l-37.247-27.089v55.707c0,15.986,12.959,28.945,28.945,28.945l0,0  c5.425,0,10.741-1.525,15.341-4.4L256,300.251v-41.103L228.912,259.618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M205.209,242.38v39.084c0,15.986,12.959,28.945,28.945,28.945c2.403,0,4.774-0.347,7.082-0.931  L256,300.251v-41.103l-27.089,0.47L205.209,242.38z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M215.367,249.767v25.232c0,15.986,12.959,28.945,28.945,28.945c2.403,0,4.774-0.347,7.082-0.931  l4.606-2.879v-40.988l-27.089,0.47L215.367,249.767z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M211.657,309.962l-4.464-4.464c-2.707-2.707-2.634-7.119,0.162-9.734l73.9-69.441l9.577,9.577   l-69.441,73.9C218.775,312.596,214.364,312.67,211.657,309.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M212.856,308.159c-0.877,3.944-5.986,3.944-6.863,0c-0.062-0.279-0.062-0.578,0-0.857   c0.877-3.944,5.986-3.944,6.863,0C212.918,307.581,212.918,307.88,212.856,308.159z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 324.8766 596.7863)",
    style: {
      fill: "#F5F5F5"
    },
    cx: 286.037,
    cy: 231.109,
    rx: 6.772,
    ry: 3.386
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M300.344,309.962l4.464-4.464c2.707-2.707,2.634-7.119-0.162-9.734l-73.9-69.441l-9.577,9.577   l69.441,73.9C293.225,312.596,297.637,312.67,300.344,309.962z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M299.144,308.159c0.877,3.944,5.986,3.944,6.863,0c0.062-0.279,0.062-0.578,0-0.857   c-0.877-3.944-5.986-3.944-6.863,0C299.082,307.581,299.082,307.88,299.144,308.159z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -97.2449 227.4727)",
    style: {
      fill: "#F5F5F5"
    },
    cx: 225.961,
    cy: 231.121,
    rx: 6.772,
    ry: 3.386
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFBE5A"
    },
    cx: 256,
    cy: 271.47,
    rx: 29.94,
    ry: 35.554
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF4B55"
    },
    points: "256,239.301 257.589,246.198 261.232,240.13 260.612,247.181 265.952,242.535   263.183,249.049 269.697,246.28 265.051,251.62 272.102,251 266.033,254.643 272.931,256.232 266.033,257.821 272.102,261.463   265.051,260.843 269.697,266.183 263.183,263.415 265.952,269.929 260.612,265.283 261.232,272.333 257.589,266.265 256,273.162   254.411,266.265 250.768,272.333 251.389,265.283 246.049,269.929 248.817,263.415 242.303,266.183 246.949,260.843   239.898,261.463 245.967,257.821 239.07,256.232 245.967,254.643 239.898,251 246.949,251.62 242.303,246.28 248.817,249.049   246.049,242.535 251.389,247.181 250.768,240.13 254.411,246.198 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#73AF00"
    },
    d: "M293.459,270.834c0,0-11.216,2.963-18.518-3.174c-8.114-6.82-14.199-10.041-16.804-11.251  c-0.893-0.415-1.891-0.414-2.785-0.002c-1.868,0.862-5.305,2.649-8.346,5.328c-4.444,3.915-18.094,11.64-20.846,11.64v16.833  l21.48,18.615l25.396-0.741L293.459,270.834z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3CC8FF"
    },
    d: "M256,315.488c-21.472,0-38.94-19.748-38.94-44.019S234.528,227.45,256,227.45  s38.94,19.748,38.94,44.019S277.472,315.488,256,315.488z M256,237.608c-15.871,0-28.782,15.191-28.782,33.861  S240.13,305.33,256,305.33c15.871,0,28.782-15.191,28.782-33.861S271.871,237.608,256,237.608z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M250.166,306.285l0.746,2.237l2.358,0.018c0.305,0.002,0.432,0.392,0.186,0.573l-1.897,1.401   l0.711,2.248c0.092,0.291-0.239,0.532-0.488,0.354l-1.919-1.371l-1.919,1.371c-0.248,0.178-0.58-0.063-0.488-0.354l0.711-2.248   l-1.897-1.401c-0.246-0.181-0.119-0.571,0.186-0.573l2.358-0.018l0.746-2.237C249.66,305.996,250.07,305.996,250.166,306.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M239.581,301.735l0.746,2.237l2.358,0.018c0.305,0.002,0.432,0.392,0.186,0.573l-1.897,1.401   l0.711,2.248c0.092,0.291-0.239,0.532-0.488,0.354l-1.919-1.371l-1.919,1.371c-0.248,0.178-0.58-0.063-0.488-0.354l0.711-2.248   l-1.897-1.401c-0.246-0.181-0.119-0.571,0.186-0.573l2.358-0.018l0.746-2.237C239.075,301.446,239.484,301.446,239.581,301.735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M231.081,294.011l0.746,2.237l2.358,0.018c0.305,0.002,0.432,0.392,0.186,0.573l-1.897,1.401   l0.711,2.248c0.092,0.291-0.239,0.532-0.488,0.354l-1.919-1.371l-1.919,1.371c-0.248,0.178-0.58-0.063-0.488-0.354l0.711-2.248   l-1.897-1.401c-0.246-0.181-0.119-0.571,0.186-0.573l2.358-0.018l0.746-2.237C230.574,293.721,230.984,293.721,231.081,294.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M225.284,283.729l0.746,2.237l2.358,0.018c0.305,0.002,0.432,0.392,0.186,0.573l-1.897,1.401   l0.711,2.248c0.092,0.291-0.239,0.532-0.488,0.354l-1.919-1.371l-1.919,1.371c-0.248,0.178-0.58-0.063-0.488-0.354l0.711-2.248   l-1.897-1.401c-0.246-0.181-0.119-0.571,0.186-0.573l2.358-0.018l0.746-2.237C224.778,283.439,225.187,283.439,225.284,283.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M222.725,271.772l0.746,2.237l2.358,0.018c0.305,0.002,0.432,0.392,0.186,0.573l-1.897,1.401   l0.711,2.248c0.092,0.291-0.239,0.532-0.488,0.354l-1.919-1.371l-1.919,1.371c-0.248,0.178-0.58-0.063-0.488-0.354l0.711-2.248   l-1.897-1.401c-0.246-0.181-0.119-0.571,0.186-0.573l2.358-0.018l0.746-2.237C222.219,271.482,222.628,271.482,222.725,271.772z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M261.819,306.285l-0.746,2.237l-2.358,0.018c-0.305,0.002-0.432,0.392-0.186,0.573l1.897,1.401   l-0.711,2.248c-0.092,0.291,0.239,0.532,0.488,0.354l1.918-1.371l1.919,1.371c0.248,0.178,0.58-0.063,0.488-0.354l-0.711-2.248   l1.897-1.401c0.246-0.181,0.119-0.571-0.186-0.573l-2.358-0.018l-0.746-2.237C262.325,305.996,261.915,305.996,261.819,306.285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M272.404,301.735l-0.746,2.237l-2.358,0.018c-0.305,0.002-0.432,0.392-0.186,0.573l1.897,1.401   l-0.711,2.248c-0.092,0.291,0.239,0.532,0.488,0.354l1.919-1.371l1.919,1.371c0.248,0.178,0.58-0.063,0.488-0.354l-0.711-2.248   l1.897-1.401c0.246-0.181,0.119-0.571-0.186-0.573l-2.358-0.018l-0.746-2.237C272.91,301.446,272.5,301.446,272.404,301.735z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M280.904,294.011l-0.746,2.237l-2.358,0.018c-0.305,0.002-0.432,0.392-0.186,0.573l1.897,1.401   l-0.711,2.248c-0.092,0.291,0.239,0.532,0.488,0.354l1.919-1.371l1.918,1.371c0.248,0.178,0.58-0.063,0.488-0.354l-0.711-2.248   l1.897-1.401c0.246-0.181,0.119-0.571-0.186-0.573l-2.358-0.018l-0.746-2.237C281.411,293.721,281.001,293.721,280.904,294.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M286.701,283.729l-0.746,2.237l-2.358,0.018c-0.305,0.002-0.432,0.392-0.186,0.573l1.897,1.401   l-0.711,2.248c-0.092,0.291,0.239,0.532,0.488,0.354l1.919-1.371l1.919,1.371c0.248,0.178,0.58-0.063,0.488-0.354l-0.711-2.248   l1.897-1.401c0.246-0.181,0.119-0.571-0.186-0.573l-2.358-0.018l-0.746-2.237C287.207,283.439,286.798,283.439,286.701,283.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M289.26,271.772l-0.746,2.237l-2.358,0.018c-0.305,0.002-0.432,0.392-0.186,0.573l1.897,1.401   l-0.711,2.248c-0.092,0.291,0.239,0.532,0.488,0.354l1.919-1.371l1.919,1.371c0.248,0.178,0.58-0.063,0.488-0.354l-0.711-2.248   l1.897-1.401c0.246-0.181,0.119-0.571-0.186-0.573l-2.358-0.018l-0.746-2.237C289.766,271.482,289.357,271.482,289.26,271.772z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M241.288,293.177l1.125,5.381h0.484v-3.671c0,0,0.801,2.561,1.932,3.671h0.917  c-0.438-0.562-1.226-1.732-1.226-2.94c0-1.666,1.325-1.893,1.325-3.673h1.136v6.613h0.664l1.229-5.894c0,0,1.014,3.686,2.923,5.894  h0.848c-0.611-0.9-1.882-3.219-1.65-6.727c0,0,1.817-0.909,1.817-3.37v-3.501c0-0.655,0.531-1.187,1.187-1.187h0.817  c0,0-1.214-2.355-2.514-2.697V279.6l-0.979,1.478c-0.934,0.202-1.485,1.066-1.485,1.991v2.132c0,0.655-0.531,1.187-1.187,1.187  h-4.244c-1.257,0-3.269,1.257-3.269,2.866s1.207,2.665,1.207,2.665L241.288,293.177z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M260.303,287.814h-0.39c-3.077,0.169-4.795,2.19-4.795,2.19l3.122,3.122v5.873h3.736v-5.873  l3.122-3.122C265.098,290.004,263.38,287.983,260.303,287.814z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 266.86,
    y: 278.21,
    style: {
      fill: "#F5F5F5"
    },
    width: 1.129,
    height: 20.81
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M267.464,278.047l-6.084,7.354c0,0-0.794-3.545,2.751-7.037l-7.83,1.428   c0,0,2.381-4.444,8.624-3.968l-6.402-5.344c0,0,5.502-0.317,8.306,3.809c0,0,1.587-4.762,6.031-4.973l-3.668,5.573   c0,0,3.668-1.869,8.747-0.229l-7.566,2.01c0,0,4.233,0.423,5.979,6.613l-6.561-4.497c0,0,2.01,2.381,1.27,7.037L267.464,278.047z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F5F5F5"
    },
    points: "189.633,226.434 174.734,218.985 185.57,232.529 191.665,232.529  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#825546"
    },
    d: "M266.593,217.809l40.199-12.369l-21.34-8.002c-3.802-1.426-7.829-2.156-11.889-2.156h-4.018  c-1.87,0-3.386,1.516-3.386,3.386v3.386H256h-10.158v-3.386c0-1.87-1.516-3.386-3.386-3.386h-4.018c-4.06,0-8.088,0.73-11.889,2.156  l-21.34,8.002l40.199,12.369c2,0.615,2.968,2.879,2.033,4.751l-4.985,9.969h27.089l-4.985-9.969  C263.624,220.688,264.593,218.424,266.593,217.809z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M261.387,201.082c4.512,6.887-2.858,14.257-9.746,9.746c-0.408-0.267-0.761-0.62-1.028-1.028  c-4.511-6.887,2.858-14.257,9.746-9.746C260.767,200.321,261.12,200.673,261.387,201.082z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFBE5A"
    },
    d: "M259.386,205.44L259.386,205.44c0,1.87-1.516,3.386-3.386,3.386h-13.544l5.78-5.78  c0.635-0.635,1.496-0.992,2.394-0.992H256C257.87,202.054,259.386,203.57,259.386,205.44z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBo);
export default __webpack_public_path__ + "static/media/BO.8be58b21a49a3d09209ec693af159cff.svg";
export { ForwardRef as ReactComponent };